<template>
    <span class="spinner">
        <font-awesome-icon
            icon="spinner"
            :class="className + ' spin fa-8x'" />
    </span>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faSpinner);

export default {
	props: {
		className: {
			type: String,
			default: "color-gray"
		}
	},
	components: {
		FontAwesomeIcon
	}
};
</script>
